import { mocked } from '@/configs';
import type { Constructor } from '@/type-utils';
import MockService, { MockState, ServiceMock } from '../MockService';
import type { ProductListService } from './ProductListService';

const initialState = {};

/**
 * Mock implementation of the ProductListService class.
 */
class ProductListServiceMock extends ServiceMock<ProductListService> {
  protected _state;

  /** @inheritdoc */
  public get state(): MockState {
    return this._state;
  }

  /** @inheritdoc */
  public getMock(): ProductListService {
    return MockService.getMockOf(this.service) as ProductListService;
  }

  /** @inheritdoc */
  public constructor(private service: Constructor<ProductListService>) {
    super();
    this._state = new MockState(initialState);
    this.initializeMockedMembers(service);
  }

  /** @inheritdoc */
  protected initializeMockedMembers(
    service: Constructor<ProductListService>
  ): void {
    const mockEnabled: boolean = mocked.ProductListService;
    MockService.mockService(
      mockEnabled,
      service,
      {
        streamProductsFromSearch: async () => {
          const mockModule = await import(
            /* webpackChunkName: "mock_search_product_list" */
            /* webpackExports: "MOCK_SEARCH_PRODUCT_LIST" */
            '@/services/serverless/ServerProductListService/mocks/MOCK_SEARCH_PRODUCT_LIST'
          );
          return mockModule.MOCK_SEARCH_PRODUCT_LIST;
        },
        streamProductsFromSkus: async () => {
          const mockModule = await import(
            /* webpackChunkName: "mock_grid_items" */
            /* webpackExports: "MOCK_GRID_ITEMS" */
            '@/services/serverless/ServerProductListService/mocks/MOCK_GRID_ITEMS'
          );
          return mockModule.MOCK_GRID_ITEMS;
        }
      },
      {},
      this.state
    );
  }
}

export default ProductListServiceMock;
